module.exports = "/assets/images/0d7c7b5c438727deeccc2645bbe2e10f.png";